import { decryptText } from 'helpers/CommonHelper';

export const CRYPTO_SECRET_KEY = 'ztohxhkzvgxzjxgyzzmg';
export const API_URL = import.meta.env.VITE_BACKEND_API_URL;
export const FILE_URL = import.meta.env.VITE_BACKEND_FILE_URL;
export const TURNSTILE_SITE_KEY = () => {
  return decryptText(import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '');
};
export const APP_CODE = '1.0.0';
export const DEVICE_TYPE = 'W';
export const FFL_ROLE_SLUG = 'ffl';
export const ADMIN_ROLE_SLUG = 'admin';
export const CUSTOMER_ROLE_SLUG = 'customer';
// export const PRODUCT_IMPORT_SAMPLE_CSV = import.meta.env.VITE_PRODUCT_IMPORT_SAMPLE;
export const PRODUCT_IMPORT_SAMPLE_CSV =
  'sample/1773331971955-97063ef2-67b2-445f-b9a5-f98cf82e6091.csv';

export const GOOGLE_MAP_API_KEY = () => {
  return decryptText(import.meta.env.VITE_GOOGLE_MAP_API_KEY || '');
};
